<template>
    <div class="addressMain">
       
        <div style="text-align: right;">
            <el-button type="primary" @click="addAddress('新增收货地址','-1')">新增收货地址</el-button>
        </div>
        
        <div v-show="addressList != ''">
            <div v-for="item in addressList" :key="item.id" class="address-itme">
                <div class="IsDefault">
                    <p>设置为默认收货地址</p>
                    <el-switch
                        v-model="item.is_default"
                        active-color="#007aff"
                        inactive-color="#f2f2f2"
                        @change="getIsDefault(item)"
                        >
                    </el-switch>
                </div>
                <div class="item-info">
                    <div>
                        <p>
                            <span>{{ item.contact }}</span>,
                            <span>{{ item.phone }}</span>
                        </p>
                        <p>{{ item.province_name }}{{ item.city_name }}{{ item.county_name }}</p>
                        <p>{{ item.address }}</p>
                    </div>
                    <div class="updataInfo">
                        <p @click="deleteAddress(item.id)">删除</p>
                        <p @click="addAddress('修改收货地址',item.id)">修改</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            addressList: []
        }
    },
    methods:{
        getAddressList(data){
            this.$store.dispatch('personal/addressListByUser',data)
                .then(res =>{
                    if(res.ok){
                        this.addressList = res.data.items
                        this.addressList.forEach(item => {
                            if(item.is_default == 1){
                                item.is_default = true
                            }else{
                                item.is_default= false
                            }
                        });
                    }
                })
        },
        addAddress(val,int){
            this.$router.push({
                path: '/addAddress',
                query: {
                    name: val,
                    id: int
                }
            })
        },
        deleteAddress(val){
            this.$confirm('确定要删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    ids: val
                }
                this.$store.dispatch('personal/addressDelete',data)
                    .then(res => {
                        if (res.ok) {
                            this.$notify({
                                title: '提示',
                                message: '删除成功',
                                type: 'success'
                            })

                            let data = {
                                pageNum: '',
                                pageSize: '999'
                            }
                            this.getAddressList(data)
                        }
                    })
            
            }).catch(() => {
                    
            });
        },
        getIsDefault(val){
            console.log("ooooooooooppppppppppppppppp");
            console.log(val);
            // if(!this.is_default){
                let data = {
                    id: val.id
                }
                this.$store.dispatch('personal/setdefault',data)
                    .then(res => {
                        if(res.ok){
                            this.$notify({
                                title: '提示',
                                message: '修改成功',
                                type: 'success'
                            })
                        }
                    })
            // }
        }
    },
    created(){
        let data = {
            pageNum: '',
            pageSize: '999'
        }
        this.getAddressList(data)
    }
}
</script>

<style scoped>
.addressMain{
    width: 770px;
    margin: 0px auto;
}
.addressMain .el-button{
    width: 200px;
}
.address-itme{
    padding: 20px 10px;
    border-bottom: 0.5px solid #f2f2f2;
    margin: 20px 10px 20px 0;
    font-size: 18px;
}

.address-itme .IsDefault{
    color: #666;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
}

.address-itme .item-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item-info p{
    line-height: 30px;
}
.updataInfo{
    color: #666666;
    font-size: 16px;
    cursor: pointer;
}
</style>